const collator = new Intl.Collator('en', {
	numeric: true,
	sensitivity: 'base',
});

export const filter_array = test_array => {
	var index = -1,
		arr_length = test_array ? test_array.length : 0,
		resIndex = -1,
		result = [];

	while (++index < arr_length) {
		var value = test_array[index];

		if (value) {
			result[++resIndex] = value;
		}
	}

	return result;
};

// GroupBy Alphabetics
// Need to Sort Data First - Or it won't necessarily be in order
// Need to Handle not Alpha Characters - 0-9[...]
export const groupByAlpha = (AllData, SortBy) => {
	var groupedCollection = {};
	var arr_length = AllData ? AllData.length : 0;
	if (arr_length > 0) {
		AllData.sort((a, b) => {
			if (SortBy === 'Asc') return collator.compare(a.name, b.name);
			else return collator.compare(b.name, a.name);
		});
	}

	for (var i = 0; i < arr_length; i++) {
		//loop throug collection
		var firstLetter = AllData[i].name.charAt(0);
		if (groupedCollection[firstLetter] === undefined) {
			groupedCollection[firstLetter] = [];
		}
		groupedCollection[firstLetter].push({
			id: AllData[i].id,
			name: AllData[i].name,
			urlSlug: AllData[i].urlSlug,
		});
	}
	return groupedCollection;
};

// ADD in SHIPPING TAX ETC...
export const getCartTotal = cartItems => {
	var total = 0;
	for (var i = 0; i < cartItems.length; i++) {
		if (cartItems[i].price) {
			total += cartItems[i].qty * cartItems[i].price;
		}
	}
	return total;
};

// Make Imperial vs Metric Later...
export const getDistanceMessage = distance => {
	var total = Math.round(distance, 2);
	var message = '';
	if (total <= 1) {
		message = '< 1 mile away';
	} else {
		message = `${total} miles away`;
	}

	return message;
};
